import { FunctionComponent, useState } from 'react';
import {
    Box,
    Link,
    Stack,
    SvgIcon,
    Tab,
    Typography,
    useTheme,
} from '@mui/material';
import { TabContext, TabList, TabPanel } from '@mui/lab';
import ArrowLeftIcon from '@heroicons/react/24/solid/ArrowLeftIcon';
import { NewImportConditionLinkCard } from '@/pages/rulesets/components/NewImportConditionLinkCard';

type TabValue = 'general' | 'priceCondition' | 'contingentCondition';

export const NewImportConditionLinkContent: FunctionComponent = () => {
    const theme = useTheme();
    const [tabValue, setTabValue] = useState<TabValue>('general');

    const handleTabChange = (_, newValue: TabValue) => {
        setTabValue(newValue);
    };

    return (
        <TabContext value={tabValue}>
            <Link
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    color: 'text.primary',
                    mb: 6,
                }}
                href='/regelwerke'
            >
                <SvgIcon
                    fontSize='small'
                    sx={{
                        mr: 2,
                    }}
                >
                    <ArrowLeftIcon />
                </SvgIcon>

                <Typography variant='subtitle2' component='span'>
                    Regelwerke
                </Typography>
            </Link>

            <Typography
                sx={{
                    mb: 8,
                }}
                variant='h4'
            >
                Neues Regelwerk anlegen
            </Typography>

            <Stack spacing={theme.page.verticalSpacing}>
                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                    <TabList onChange={handleTabChange}>
                        <Tab label='Allgemeine Konfiguration' value='general' />
                        <Tab
                            label='Regelwerk Verfügbarkeit'
                            value='contingentCondition'
                            disabled
                        />
                        <Tab
                            label='Regelwerk Preis'
                            value='priceCondition'
                            disabled
                        />
                    </TabList>
                </Box>

                <TabPanel value='general'>
                    <NewImportConditionLinkCard />
                </TabPanel>
            </Stack>
        </TabContext>
    );
};
